import styles from './style.postcss';

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Person, AdultPicture } from 'omni-common-ui';

const UserCardPlaceholder = ({ className, isLoading }) => {
  const classes = classnames(styles.UserCardPlaceholder,
      className,
      { [styles.__loading]: isLoading });
  return <Person className={classes}>
    <AdultPicture className={styles.UserCard_picture} />
    <div className={styles.UserCardPlaceholder_placeholderText}>&nbsp;</div>
    <div className={styles.UserCardPlaceholder_placeholderText}>&nbsp;</div>
  </Person>;
};

UserCardPlaceholder.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default UserCardPlaceholder;



// WEBPACK FOOTER //
// ./components/UserCardPlaceholder/index.jsx